import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPublishEnglishIqSupplyV1Response } from './publish-english-iq-supply-v1-response';
import { publishEnglishIqSupplyV1ResponseSchema } from './publish-english-iq-supply-v1-response';

export async function publishEnglishIqSupplyV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IPublishEnglishIqSupplyV1Response>> {
  return postRequest<IPublishEnglishIqSupplyV1Response>({
    options,
    path: '/sys/english-iq/supply/v1',
    schema: publishEnglishIqSupplyV1ResponseSchema,
  });
}
